import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{staticClass:"d-flex justify-center align-center",attrs:{"height":"100%"}},[_c('div',[_c('div',{staticClass:"text-h1 nexa-bold text-center"},[_vm._v("404")]),_c('h3',{staticClass:"nexa-bold mt-3"},[_vm._v("Página não encontrada!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }